import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, Target, Users, TrendingUp } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function ConsultancyLanding() {
  return (
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16" data-testid="consultancy-landing-page">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <div>
          <div className="overline text-accent mb-3">Yapay Zekâ Destekli</div>
          <h1 className="font-display text-4xl sm:text-5xl font-bold tracking-tight leading-tight">
            LGS ve YKS <span className="hero-gradient-text">tercih danışmanlığı</span> artık cebinizde.
          </h1>
          <p className="text-muted-foreground mt-4 leading-relaxed max-w-xl">
            Puan, sıralama ve hedeflerinizi girin; yapay zekâ hem zorlayıcı hem gerçekçi hem de güvenli
            okul-bölüm önerilerini gerekçesiyle sunsun. Sonuç bir kestirimdir; yerleştirme garanti değildir.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Button asChild size="lg" data-testid="consultancy-cta"><Link to="/panel/tercih-danismanligi">Hemen Başla</Link></Button>
            <Button asChild size="lg" variant="outline"><Link to="/kayit">Ücretsiz Kayıt</Link></Button>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4">
          {[
            { i: Target, t: "Reach / Realistic / Safe", d: "Üç kategoride net öneriler." },
            { i: Sparkles, t: "Gerekçeli Öneri", d: "Her önerinin neden verildiği açıklanır." },
            { i: TrendingUp, t: "Geçmiş Veriler", d: "Yıllara göre sıralama trendleri." },
            { i: Users, t: "Aile Görünümü", d: "Veli ve öğrenci birlikte inceleyebilir." },
          ].map(({ i: Icon, t, d }) => (
            <div key={t} className="p-6 rounded-xl border border-border bg-card">
              <Icon className="h-6 w-6 text-accent mb-3" />
              <div className="font-display font-bold text-base mb-1">{t}</div>
              <div className="text-sm text-muted-foreground">{d}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
